module.exports = __webpack_public_path__ + "static/media/Find a Provider.d2c51605.svg";